export default function AnchorData () {
    const anchor = window.location.hash
        ? JSON.parse(decodeURIComponent(window.location.hash.replace("#", "")))
        : null;
    console.log("anchor", anchor);
    return anchor;
}